import { DomainEvent } from "@/domains/events"

export class LockAddedToRepositoryEvent extends DomainEvent {
  static readonly TYPE = "lock.added-to-repository"
  readonly type = LockAddedToRepositoryEvent.TYPE
  constructor(public readonly lockId: number) {
    super()
  }
}

export class LockCreatedEvent extends DomainEvent {
  static readonly TYPE = "lock.created"
  readonly type = LockCreatedEvent.TYPE
  constructor(
    public readonly groupId: string,
    public readonly lockId: number,
    public readonly amount: bigint,
    public readonly secondsToExpire: number,
    public readonly transactionHash: string,
  ) {
    super()
  }
}

export class LockTransferredOutEvent extends DomainEvent {
  static readonly TYPE = "lock.transferred"
  readonly type = LockTransferredOutEvent.TYPE
  constructor(
    public readonly groupId: string,
    public readonly lockId: number,
    public readonly fromAccount: string,
    public readonly toAccount: string,
    public readonly transactionHash: string,
  ) {
    super()
  }
}

export class LockReceivedEvent extends DomainEvent {
  static readonly TYPE = "lock.received"
  readonly type = LockReceivedEvent.TYPE
  constructor(
    public readonly lockId: number,
    public readonly fromAccount: string,
    public readonly toAccount: string,
    public readonly transactionHash: string,
  ) {
    super()
  }
}

export class LockAmountIncreasedEvent extends DomainEvent {
  static readonly TYPE = "lock.amount-increased"
  readonly type = LockAmountIncreasedEvent.TYPE
  constructor(
    public readonly groupId: string,
    public readonly lockId: number,
    public readonly amount: bigint,
    public readonly transactionHash: string,
  ) {
    super()
  }
}

export class LockDurationExtendedEvent extends DomainEvent {
  static readonly TYPE = "lock.duration-extended"
  readonly type = LockDurationExtendedEvent.TYPE
  constructor(
    public readonly groupId: string,
    public readonly lockId: number,
    public readonly secondsExtended: number,
    public readonly transactionHash: string,
  ) {
    super()
  }
}

export class LockDurationMultiExtendedEvent extends DomainEvent {
  static readonly TYPE = "lock.duration-multi-extended"
  readonly type = LockDurationMultiExtendedEvent.TYPE
  constructor(
    public readonly groupId: string,
    public readonly lockIds: number[], // Array of NFT IDs that had duration extended
    public readonly secondsExtended: number,
    public readonly transactionHash: string,
  ) {
    super()
  }
}

export class LockMergedEvent extends DomainEvent {
  static readonly TYPE = "lock.merged"
  readonly type = LockMergedEvent.TYPE
  constructor(
    public readonly groupId: string,
    public readonly fromTokenId: number,
    public readonly toTokenId: number,
    public readonly transactionHash: string,
  ) {
    super()
  }
}

export class LockResetEvent extends DomainEvent {
  static readonly TYPE = "lock.reset"
  readonly type = LockResetEvent.TYPE
  constructor(
    public readonly groupId: string,
    public readonly tokenId: number,
    public readonly transactionHash: string,
  ) {
    super()
  }
}

export class LockTokensWithdrawnEvent extends DomainEvent {
  static readonly TYPE = "lock.tokens-withdrawn"
  readonly type = LockTokensWithdrawnEvent.TYPE
  constructor(
    public readonly groupId: string,
    public readonly tokenId: number,
    public readonly transactionHash: string,
  ) {
    super()
  }
}

export class LockNftSwitchedEvent extends DomainEvent {
  static readonly TYPE = "lock.nft-switched"
  readonly type = LockNftSwitchedEvent.TYPE
  constructor(
    public readonly fromNftId: number,
    public readonly toNftId: number,
  ) {
    super()
  }
}

export class LockVotedEvent extends DomainEvent {
  static readonly TYPE = "lock.voted"
  readonly type = LockVotedEvent.TYPE
  constructor(
    public readonly lockIds: number[], // Array of NFT IDs that voted
    public readonly transactionHash: string,
  ) {
    super()
  }
}
